/**
 * @generated SignedSource<<8238730200b5ddf239b518d4b6f69e0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAssignmentRuleInput = {
  assignmentRuleId: string;
  clientMutationId?: string | null;
};
export type licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation$variables = {
  input: DeleteAssignmentRuleInput;
};
export type licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation$data = {
  readonly LicenseManagement: {
    readonly deleteAssignmentRule: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation = {
  response: licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation$data;
  variables: licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LicenseManagementMutations",
    "kind": "LinkedField",
    "name": "LicenseManagement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "DeleteAssignmentRulePayload",
        "kind": "LinkedField",
        "name": "deleteAssignmentRule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "428b5270d3c1e9380bd43de55ad47902",
    "id": null,
    "metadata": {},
    "name": "licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation",
    "operationKind": "mutation",
    "text": "mutation licensesAccountGroupAssignmentCard_deleteGroupAssignmentRuleMutation(\n  $input: DeleteAssignmentRuleInput!\n) {\n  LicenseManagement {\n    deleteAssignmentRule(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0eef58ffb86b948b348d2e9579992cd";

export default node;
